module.exports = __webpack_public_path__ + "static/media/ic_successverification.87bd804b.png";